import React from 'react'

export const ConnectedSourcesIllustration = () => {
  return (
    <svg
      width="100%"
      height="260"
      viewBox="0 0 507 260"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M191.159 2.51685C198.829 2.51685 206.165 6.06935 212.868 12.5491C219.572 19.0305 225.626 28.4263 230.717 40.0637C240.899 63.3375 247.205 95.5145 247.205 131.074C247.205 166.635 240.899 198.811 230.717 222.085C225.626 233.723 219.572 243.118 212.868 249.6C206.165 256.079 198.829 259.631 191.159 259.631C183.488 259.631 176.152 256.08 169.45 249.6C162.745 243.118 156.692 233.723 151.601 222.085C141.419 198.811 135.112 166.635 135.112 131.074C135.112 95.5145 141.419 63.3375 151.601 40.0637C156.692 28.4265 162.746 19.0305 169.45 12.5491C176.152 6.06937 183.488 2.51696 191.159 2.51685Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M154.636 2.51685C180.154 2.51699 203.287 16.8662 220.056 40.1282C236.823 63.3898 247.206 95.543 247.206 131.074C247.206 166.606 236.823 198.759 220.056 222.021C203.288 245.283 180.154 259.631 154.636 259.631C129.117 259.631 105.983 245.283 89.2147 222.021C72.447 198.759 62.0644 166.606 62.0643 131.074C62.0643 95.543 72.447 63.3898 89.2147 40.1282C105.983 16.866 129.117 2.51685 154.636 2.51685Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M340.477 2.51685C365.995 2.51699 389.129 16.8662 405.897 40.1282C422.664 63.3898 433.047 95.543 433.047 131.074C433.047 166.606 422.664 198.759 405.897 222.021C389.129 245.283 365.995 259.631 340.477 259.631C314.958 259.631 291.824 245.283 275.056 222.021C258.288 198.759 247.905 166.606 247.905 131.074C247.905 95.543 258.288 63.3898 275.056 40.1282C291.824 16.866 314.958 2.51685 340.477 2.51685Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M303.952 2.51685C311.623 2.51685 318.959 6.06935 325.661 12.5491C332.365 19.0305 338.419 28.4263 343.511 40.0637C353.693 63.3375 359.999 95.5145 359.999 131.074C359.999 166.635 353.693 198.811 343.511 222.085C338.419 233.723 332.365 243.118 325.661 249.6C318.959 256.079 311.623 259.631 303.952 259.631C296.281 259.631 288.946 256.08 282.243 249.6C275.539 243.118 269.486 233.723 264.395 222.085C254.212 198.811 247.905 166.635 247.905 131.074C247.905 95.5145 254.212 63.3375 264.395 40.0637C269.486 28.4265 275.539 19.0305 282.243 12.5491C288.946 6.06937 296.281 2.51696 303.952 2.51685Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M291.062 2.51685C296.917 2.51685 302.55 6.03318 307.723 12.5159C312.893 18.9951 317.565 28.3923 321.494 40.0354C329.352 63.3181 334.218 95.5055 334.218 131.074C334.218 166.644 329.352 198.831 321.494 222.114C317.565 233.757 312.893 243.154 307.723 249.633C302.55 256.116 296.917 259.631 291.062 259.631C285.206 259.631 279.573 256.116 274.4 249.633C269.231 243.154 264.56 233.757 260.63 222.114C252.772 198.831 247.905 166.644 247.905 131.074C247.905 95.5054 252.772 63.3181 260.63 40.0354C264.559 28.3924 269.231 18.9951 274.4 12.5159C279.573 6.03328 285.206 2.51696 291.062 2.51685Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <rect
        x="79.1568"
        y="17.5255"
        width="35.3616"
        height="35.3616"
        rx="17.6808"
        fill="white"
      />
      <rect
        x="79.1568"
        y="17.5255"
        width="35.3616"
        height="35.3616"
        rx="17.6808"
        stroke="#A6A6A6"
        strokeWidth="0.638416"
      />
      <g clipPath="url(#clip0_5282_11407)">
        <path
          d="M94.1624 25.8344C91.1087 26.0609 88.5128 26.2691 88.3907 26.2935C88.0485 26.3547 87.7372 26.5873 87.5908 26.8935L87.4626 27.163L87.4749 33.5844L87.4931 40.0058L87.6885 40.4038C87.7986 40.624 88.5437 41.6526 89.3559 42.7113C90.9623 44.7987 91.0782 44.9152 91.6889 44.9763C91.8662 44.9945 93.1976 44.9334 94.639 44.8478C96.0867 44.7561 98.4073 44.6152 99.8001 44.5358C105.749 44.1739 105.443 44.2044 105.785 43.9106C106.213 43.5556 106.182 44.1371 106.2 36.3325C106.213 29.7152 106.206 29.2809 106.109 29.0788C105.993 28.8523 105.785 28.6932 103.073 26.7832C101.259 25.51 101.131 25.4426 100.318 25.4302C99.9828 25.4182 97.2099 25.6017 94.1624 25.8344ZM101.027 26.6729C101.284 26.789 103.159 28.099 103.434 28.3502C103.507 28.4238 103.531 28.485 103.495 28.5217C103.409 28.5953 91.8044 29.287 91.4687 29.2379C91.3161 29.2135 91.0902 29.1218 90.962 29.0358C90.4305 28.6746 89.1114 27.5911 89.1114 27.5117C89.1114 27.3035 89.0686 27.3035 94.242 26.9303C95.2315 26.8629 96.8561 26.7406 97.8457 26.6609C99.9889 26.4894 100.631 26.4956 101.027 26.6729ZM104.716 30.0214C104.802 30.107 104.875 30.2723 104.899 30.4314C104.917 30.5785 104.93 33.3208 104.917 36.516C104.899 42.0006 104.893 42.3436 104.789 42.5027C104.728 42.6006 104.606 42.7048 104.514 42.7353C104.258 42.8395 92.0979 43.5313 91.8476 43.4577C91.7317 43.4271 91.5726 43.3292 91.4873 43.2436L91.3405 43.0845L91.3223 37.1714C91.31 33.0211 91.3223 31.1847 91.3714 31.0194C91.4081 30.8971 91.4996 30.7499 91.5792 30.7012C91.6893 30.6276 92.41 30.5665 94.8897 30.4197C96.6305 30.3218 99.3238 30.1565 100.869 30.0648C104.545 29.8379 104.533 29.8379 104.716 30.0214Z"
          fill="black"
        />
        <path
          d="M101.027 26.6728C101.284 26.7889 103.159 28.0989 103.433 28.3501C103.507 28.4237 103.531 28.4848 103.495 28.5216C103.409 28.5952 91.8043 29.2869 91.4687 29.2378C91.3161 29.2134 91.0902 29.1216 90.9619 29.0357C90.4305 28.6745 89.1114 27.591 89.1114 27.5116C89.1114 27.3034 89.0686 27.3034 94.242 26.9302C95.2315 26.8628 96.8561 26.7405 97.8456 26.6608C99.9889 26.4893 100.63 26.4955 101.027 26.6728ZM104.716 30.0213C104.802 30.1069 104.875 30.2721 104.899 30.4313C104.917 30.5784 104.93 33.3207 104.917 36.5159C104.899 42.0005 104.893 42.3435 104.789 42.5026C104.728 42.6005 104.606 42.7047 104.514 42.7352C104.258 42.8394 92.0979 43.5312 91.8476 43.4576C91.7317 43.427 91.5726 43.3291 91.4872 43.2435L91.3405 43.0844L91.3223 37.1713C91.31 33.021 91.3223 31.1846 91.3714 31.0193C91.4081 30.8969 91.4996 30.7498 91.5792 30.7011C91.6892 30.6275 92.41 30.5664 94.8897 30.4196C96.6305 30.3217 99.3238 30.1564 100.869 30.0647C104.545 29.8378 104.533 29.8378 104.716 30.0213Z"
          fill="white"
        />
        <path
          d="M101.448 32.0474C100.789 32.0903 100.202 32.1515 100.135 32.1883C99.9336 32.2924 99.8115 32.4639 99.7872 32.6598C99.7691 32.8618 99.8301 32.8862 100.489 32.966L100.776 33.0027V35.6165C100.776 37.1711 100.752 38.1997 100.722 38.1691C100.691 38.1323 99.8239 36.8103 98.7915 35.2309C97.7594 33.6457 96.9043 32.3416 96.8919 32.3296C96.8795 32.3172 96.2078 32.3539 95.4018 32.4093C94.4122 32.4767 93.8687 32.5378 93.7587 32.599C93.5814 32.6907 93.3859 33.0151 93.3859 33.2296C93.3859 33.3581 93.6181 33.4255 94.1067 33.4255H94.3631V40.9423L93.9479 41.0709C93.6242 41.1688 93.5142 41.23 93.4593 41.3523C93.3616 41.5606 93.3678 41.7502 93.4655 41.7502C93.5022 41.7502 94.1924 41.7073 94.9861 41.6585C96.5559 41.5667 96.7328 41.5238 96.8977 41.1994C96.9467 41.1014 96.9892 40.9973 96.9892 40.9667C96.9892 40.9423 96.7756 40.8688 96.5188 40.8076C96.2561 40.7465 95.9935 40.6853 95.9386 40.6729C95.8347 40.6423 95.8286 40.4526 95.8286 37.8203V34.9983L97.6852 37.9182C99.6335 40.9787 99.878 41.3279 100.177 41.4808C100.55 41.6767 101.497 41.542 101.973 41.23L102.12 41.1382L102.132 36.9636L102.15 32.7829L102.474 32.7217C102.859 32.6481 103.036 32.4708 103.036 32.1646C103.036 31.9688 103.024 31.9564 102.84 31.9626C102.731 31.9676 102.102 32.0044 101.448 32.0474Z"
          fill="black"
        />
      </g>
      <rect
        x="123.2"
        y="90.5729"
        width="35.3616"
        height="35.3616"
        rx="17.6808"
        fill="white"
      />
      <rect
        x="123.2"
        y="90.5729"
        width="35.3616"
        height="35.3616"
        rx="17.6808"
        stroke="#A6A6A6"
        strokeWidth="0.638416"
      />
      <g clipPath="url(#clip1_5282_11407)">
        <g clipPath="url(#clip2_5282_11407)">
          <g clipPath="url(#clip3_5282_11407)">
            <path
              d="M130.881 98.2537H150.881V118.254H130.881V98.2537Z"
              fill="#2F2F30"
            />
            <path
              d="M146.406 107.039C146.406 107.81 145.837 108.45 145.098 108.561C144.746 108.016 144.141 107.65 143.45 107.634C143.373 107.451 143.33 107.25 143.33 107.039C143.33 106.189 144.021 105.499 144.868 105.499C145.715 105.499 146.406 106.191 146.406 107.039ZM144.701 103.179C143.852 103.179 143.163 103.871 143.163 104.719C143.163 105.047 143.267 105.352 143.443 105.603C143.809 105.239 144.313 105.015 144.868 105.015C145.32 105.015 145.737 105.165 146.074 105.416C146.18 105.208 146.241 104.97 146.241 104.721C146.239 103.871 145.55 103.179 144.701 103.179ZM141.438 110.133C141.326 110.106 141.208 110.092 141.088 110.092C140.24 110.092 139.551 110.784 139.551 111.632C139.551 112.48 140.242 113.172 141.088 113.172C141.935 113.172 142.626 112.48 142.626 111.632C142.626 111.598 142.624 111.567 142.622 111.533C142.034 111.286 141.587 110.766 141.438 110.133ZM139.065 111.632C139.065 111.377 139.113 111.132 139.201 110.906C139.106 110.888 139.009 110.877 138.907 110.877C138.058 110.877 137.37 111.569 137.37 112.417C137.37 113.267 138.061 113.957 138.907 113.957C139.386 113.957 139.813 113.737 140.095 113.394C139.481 113.048 139.065 112.387 139.065 111.632ZM135.498 111.682C135.498 112.532 136.189 113.222 137.036 113.222C137.04 113.222 137.047 113.222 137.051 113.222C136.945 112.975 136.884 112.704 136.884 112.419C136.884 111.591 137.381 110.881 138.092 110.567C137.817 110.305 137.444 110.142 137.036 110.142C136.189 110.142 135.498 110.834 135.498 111.682ZM136.893 107.715C136.044 107.715 135.356 108.407 135.356 109.255C135.356 109.606 135.473 109.929 135.672 110.189C136.031 109.859 136.51 109.658 137.036 109.658C137.476 109.658 137.885 109.8 138.217 110.04C138.354 109.809 138.433 109.54 138.433 109.255C138.433 108.405 137.742 107.715 136.893 107.715ZM138.79 104.835C137.984 104.835 137.329 105.49 137.329 106.298C137.329 107.105 137.984 107.761 138.79 107.761C139.596 107.761 140.251 107.105 140.251 106.298C140.251 105.49 139.596 104.835 138.79 104.835ZM143.407 108.129C142.558 108.129 141.872 108.819 141.872 109.667C141.872 110.515 142.561 111.205 143.407 111.205C144.254 111.205 144.943 110.515 144.943 109.667C144.943 108.819 144.256 108.129 143.407 108.129ZM141.05 104.088C141.05 104.939 141.741 105.628 142.588 105.628C142.687 105.628 142.784 105.619 142.879 105.601C142.75 105.334 142.678 105.036 142.678 104.721C142.678 103.986 143.071 103.342 143.658 102.987C143.38 102.718 143.003 102.551 142.585 102.551C141.741 102.548 141.05 103.238 141.05 104.088Z"
              fill="#F9EFE4"
            />
          </g>
        </g>
      </g>
      <rect
        x="63.0434"
        y="185.105"
        width="35.3616"
        height="35.3616"
        rx="17.6808"
        fill="white"
      />
      <rect
        x="63.0434"
        y="185.105"
        width="35.3616"
        height="35.3616"
        rx="17.6808"
        stroke="#A6A6A6"
        strokeWidth="0.638416"
      />
      <g clipPath="url(#clip4_5282_11407)">
        <path
          d="M70.8502 204.473L79.037 212.659C74.8562 211.953 71.5568 208.653 70.8502 204.473Z"
          fill="#5E6AD2"
        />
        <path
          d="M70.7242 202.25L81.2596 212.786C81.8862 212.752 82.4974 212.661 83.0881 212.517L70.9923 200.422C70.8488 201.012 70.7577 201.624 70.7242 202.25Z"
          fill="#5E6AD2"
        />
        <path
          d="M71.5167 198.849L84.6604 211.993C85.1391 211.787 85.5986 211.546 86.0353 211.271L72.2384 197.474C71.9639 197.911 71.7221 198.37 71.5167 198.849Z"
          fill="#5E6AD2"
        />
        <path
          d="M73.1289 196.268C74.9641 194.136 77.6828 192.785 80.717 192.785C86.2438 192.785 90.7242 197.266 90.7242 202.793C90.7242 205.827 89.3739 208.545 87.2415 210.381L73.1289 196.268Z"
          fill="#5E6AD2"
        />
      </g>
      <rect
        x="365.975"
        y="0.338007"
        width="35.3616"
        height="35.3616"
        rx="17.6808"
        fill="white"
      />
      <rect
        x="365.975"
        y="0.338007"
        width="35.3616"
        height="35.3616"
        rx="17.6808"
        stroke="#A6A6A6"
        strokeWidth="0.638416"
      />
      <g clipPath="url(#clip5_5282_11407)">
        <path
          d="M378.031 18.644C380.447 18.644 382.406 20.6028 382.406 23.019C382.406 25.4352 380.447 27.394 378.031 27.394C375.615 27.394 373.656 25.4352 373.656 23.019C373.656 20.6028 375.615 18.644 378.031 18.644ZM389.281 18.644C391.697 18.644 393.656 20.6028 393.656 23.019C393.656 25.4352 391.697 27.394 389.281 27.394C386.865 27.394 384.906 25.4352 384.906 23.019C384.906 20.6028 386.865 18.644 389.281 18.644ZM383.656 8.64404C386.072 8.64404 388.031 10.6028 388.031 13.019C388.031 15.4352 386.072 17.394 383.656 17.394C381.24 17.394 379.281 15.4352 379.281 13.019C379.281 10.6028 381.24 8.64404 383.656 8.64404Z"
          fill="url(#paint0_radial_5282_11407)"
        />
      </g>
      <rect
        x="415.389"
        y="137.839"
        width="35.3616"
        height="35.3616"
        rx="17.6808"
        fill="white"
      />
      <rect
        x="415.389"
        y="137.839"
        width="35.3616"
        height="35.3616"
        rx="17.6808"
        stroke="#A6A6A6"
        strokeWidth="0.638416"
      />
      <g clipPath="url(#clip6_5282_11407)">
        <path
          d="M433.07 145.766C427.55 145.766 423.07 150.244 423.07 155.766C423.07 160.185 425.935 163.933 429.91 165.256C430.41 165.348 430.593 165.039 430.593 164.776C430.593 164.536 430.584 163.75 430.58 162.914C427.798 163.519 427.211 161.734 427.211 161.734C426.756 160.578 426.1 160.271 426.1 160.271C425.193 159.65 426.169 159.663 426.169 159.663C427.173 159.734 427.702 160.694 427.702 160.694C428.593 162.222 430.041 161.78 430.612 161.525C430.701 160.878 430.961 160.437 431.247 160.188C429.025 159.935 426.691 159.077 426.691 155.246C426.691 154.154 427.081 153.262 427.721 152.561C427.617 152.309 427.275 151.292 427.818 149.915C427.818 149.915 428.658 149.646 430.569 150.94C432.208 150.491 433.937 150.491 435.577 150.94C437.485 149.646 438.324 149.915 438.324 149.915C438.868 151.292 438.526 152.309 438.422 152.561C439.062 153.262 439.451 154.154 439.451 155.246C439.451 159.086 437.112 159.932 434.885 160.18C435.245 160.49 435.565 161.1 435.565 162.032C435.565 163.37 435.553 164.446 435.553 164.776C435.553 165.042 435.733 165.354 436.24 165.256C440.209 163.93 443.07 160.183 443.07 155.766C443.07 150.244 438.593 145.766 433.07 145.766ZM426.815 160.012C426.793 160.062 426.715 160.076 426.644 160.042C426.573 160.008 426.531 159.942 426.555 159.892C426.578 159.842 426.654 159.827 426.727 159.861C426.799 159.895 426.841 159.962 426.815 160.012ZM427.307 160.452C427.26 160.496 427.167 160.475 427.103 160.405C427.04 160.335 427.026 160.242 427.074 160.198C427.122 160.153 427.213 160.174 427.279 160.244C427.345 160.313 427.357 160.406 427.307 160.451V160.452ZM427.645 161.012C427.584 161.054 427.485 161.014 427.421 160.925C427.358 160.836 427.36 160.73 427.421 160.685C427.483 160.641 427.581 160.681 427.645 160.769C427.708 160.858 427.707 160.969 427.645 161.012V161.012ZM428.216 161.662C428.161 161.722 428.044 161.706 427.959 161.622C427.873 161.538 427.847 161.427 427.902 161.366C427.957 161.306 428.075 161.323 428.161 161.406C428.247 161.49 428.274 161.603 428.216 161.663V161.662ZM428.953 161.881C428.929 161.961 428.817 161.995 428.703 161.961C428.59 161.927 428.516 161.835 428.539 161.756C428.562 161.677 428.675 161.64 428.789 161.676C428.903 161.712 428.977 161.802 428.953 161.882V161.881ZM429.793 161.974C429.796 162.057 429.7 162.125 429.581 162.127C429.463 162.128 429.365 162.063 429.364 161.982C429.363 161.9 429.457 161.831 429.577 161.829C429.697 161.827 429.793 161.893 429.793 161.975L429.793 161.974ZM430.618 161.943C430.632 162.023 430.55 162.106 430.431 162.128C430.313 162.15 430.208 162.1 430.193 162.02C430.179 161.94 430.263 161.855 430.379 161.833C430.495 161.812 430.602 161.862 430.617 161.944L430.618 161.943Z"
          fill="#161614"
        />
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_5282_11407"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(383.638 20.1719) scale(13.2398 12.4112)"
        >
          <stop stopColor="#FFB900" />
          <stop offset="0.6" stopColor="#F95D8F" />
          <stop offset="1" stopColor="#F95353" />
        </radialGradient>
        <clipPath id="clip0_5282_11407">
          <rect
            width="20"
            height="20"
            fill="currentColor"
            transform="translate(86.8376 25.2063)"
          />
        </clipPath>
        <clipPath id="clip1_5282_11407">
          <rect
            width="20"
            height="20"
            fill="currentColor"
            transform="translate(130.881 98.2537)"
          />
        </clipPath>
        <clipPath id="clip2_5282_11407">
          <rect
            width="20"
            height="20"
            fill="currentColor"
            transform="translate(130.881 98.2537)"
          />
        </clipPath>
        <clipPath id="clip3_5282_11407">
          <rect
            x="130.881"
            y="98.2537"
            width="20"
            height="20"
            rx="10"
            fill="currentColor"
          />
        </clipPath>
        <clipPath id="clip4_5282_11407">
          <rect
            width="20"
            height="20"
            fill="currentColor"
            transform="translate(70.7242 192.785)"
          />
        </clipPath>
        <clipPath id="clip5_5282_11407">
          <rect
            width="20"
            height="20"
            fill="currentColor"
            transform="translate(373.656 8.0188)"
          />
        </clipPath>
        <clipPath id="clip6_5282_11407">
          <rect
            width="20"
            height="20"
            fill="currentColor"
            transform="translate(423.07 145.52)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
